export default {
  'Sample photo': 'सैंपल तस्वीर',
  Removing: 'हटाया जा रहा है',
  Edit: 'संपादित करें',
  'Adjust Picture': 'तस्वीर समायोजित करें',
  Restore: 'रिस्टोर करें',
  Eraser: 'इरेज़र',
  Size: 'साइज़',
  Background: 'बैकग्राउंड',
  Custom: 'कस्टम',
  Presets: 'प्रीसेट',
  'Add Image': 'छवि जोड़ें',
  'Scale to Fit': 'फिट करें',
  'Full Width': 'पूरी चौड़ाई',
  'Full Height': 'पूरी लम्बाई',
  Move: 'मूव करें',
  Undo: 'अनडू करें',
  Redo: 'रीडू करें',
  Enlarge: 'बढ़ाएं',
  Reduce: 'घटाएं',
  //2022.09.28 xxy
  BGRemover: {
    title: 'HitPaw ऑनलाइन बैकग्राउंड रिमूवर',
    desc: 'अपनी तस्वीरों के बैकग्राउंड को 100% स्वचालित और मुफ़्त तरीके से आसानी से हटाएं',
    imgAlt: 'photo background remover',
    submitBtn: 'बैकग्राउंड हटाएं',
  },
  BGChanger: {
    title: 'HitPaw Photo Background Changer',
    desc: 'Extremely easy to change photo background 100% automatically & free',
    imgAlt: 'photo background change',
    submitBtn: 'Change Background',
  },
  "Shadows" : "Shadow",
  "Intensity" : "Opacity",
  "Radius" : "Radius",
  "Color" : "Color",
  "Move" : "Move Shadow",
  "2D move" : "2D",
  "3D move" : "3D",
  "Move the shadow" : "Drag the shadow around in the image",
      "Upload failed, click to try again": "Upload failed, click to try again",
};
